import { useTranslation as useGenericTranslation } from "waapi/front-utils/hooks/useTranslation/hook.js";
import type { TranslationDictionary } from "./types.js";

export const useTranslation = () => useGenericTranslation<TranslationDictionary>();
